import { Signal } from '@angular/core';
import { StringColumn } from '../types/grid';
import { ColumnOptions } from '../types/column-options';
import { ColumnHostRef } from '../types/refs';

export interface StringColumnOptions<TRow extends object> extends ColumnOptions<TRow, string> {
  rowGroup?: boolean;
  aggFunc?: string;
  multiline?: boolean;
  /** Cell text and group/filter key (AG Grid `valueFormatter` + `keyCreator`). */
  format?: (value: string) => string | Signal<string>;
}

export function stringColumn<TRow extends object>(ref: ColumnHostRef<TRow>,
                                                  options: StringColumnOptions<TRow>): StringColumn<TRow> {
  const column: StringColumn<TRow> = {
    ...options,
    type: 'string'
  }
  ref.createColumn(column);
  return column;
}
